import { useMutationWithResultNotification } from '../useMutationWithResultNotification';
import { removeOrganizationUserAccessProfile } from '../../accessProfiles';
import { IMutationProps } from '../../../interfaces/ui';

export type RemoveOrganizationUserAccessProfileProps = {
  userId: string;
  accessProfileId: string;
};

type useRemoveOrganizationUserAccessProfileParams = {
  organizationId: string;
};

export const useRemoveOrganizationUserAccessProfile = (
  params: useRemoveOrganizationUserAccessProfileParams,
  options: IMutationProps
) => {
  return useMutationWithResultNotification({
    asyncApiFunction: async (
      body: RemoveOrganizationUserAccessProfileProps
    ) => {
      await removeOrganizationUserAccessProfile(params.organizationId, {
        user_id: body.userId,
        access_profile_id: body.accessProfileId,
      });
    },
    onSuccess: () => {
      if (options.successFb) options.successFb();
    },
    onErrorArray: (_) => {
      if (options.errorFb) options.errorFb();
    },
    resetOnResult: true,
  });
};
